import { useState, useEffect } from "react";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { NotificationMapping } from "./NotificationsMapping";
import {
  GetLastRewardNotifications,
  GetNotificationCount,
  GetNotificationHistory,
  ReadNotificationStatus,
} from "../redux/actions/membersActions";
import { Cookies } from "../helpers";

const useFirebaseMessaging = (history, store) => {
  const [deviceToken, setDeviceToken] = useState(null);
  useEffect(() => {
    try {
      const excludedRoutes = ["/spinandwinwheel"]; // Add the paths you want to exclude

      if (excludedRoutes.includes(window.location.pathname.toLowerCase())) {
        console.log("Notification permission request skipped on this route.");
        return;
      }

      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log("Service worker registered:", registration);
        });
      const firebaseConfig = {
        apiKey: "AIzaSyAr96vequuZVFZJgY4yJkSDzo8mQx8AArs",
        authDomain: "winners-d80a6.firebaseapp.com",
        projectId: "winners-d80a6",
        storageBucket: "winners-d80a6.appspot.com",
        messagingSenderId: "814775924804",
        appId: "1:814775924804:web:b45a54cf50618812a0e411",
        measurementId: "G-MJ8HV9D575",
      };

      const app = initializeApp(firebaseConfig);
      const messaging = getMessaging(app);

      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          console.log("Notification permission granted.");

          getToken(messaging, {
            vapidKey:
              "BP65KtI8SqN3CT8gJsa5zH1LDBAPAZAAZXk_nt5vTSHtLjH2MNLMBBHY9C6eQ-3Xfz36JlODoirI8TtdzIaoSJU",
          })
            .then((token) => {
              console.log("Device token:", token);
              setDeviceToken(token);
            })
            .catch((err) => {
              console.log("Error getting device token:", err);
            });
          onMessage(
            messaging,
            (payload) => {
              // Logic to be handled when we first receive a notification from firebase
              // localStorage.getItem("NotificationCenterPage") is to now the last page the user was opening in notification center, and so that i can request for the data on the same page
              const notificationId =
                payload && payload.data && payload.data.typeId;
              const data = {
                pageSize: 10,
                pageIndex: localStorage.getItem("NotificationCenterPage")
                  ? Number(localStorage.getItem("NotificationCenterPage")) - 1
                  : 0,
                notificationTypeId: window.location.pathname.split("/")[3],
              };
              (window.location.pathname.includes(`/account/notifications/2`) ||
                window.location.pathname.includes(
                  `/account/notifications/1`
                )) &&
                store.dispatch(GetNotificationHistory(data));
              window.location.pathname.includes(`/account`) &&
                store.dispatch(GetNotificationCount());
              window.location.pathname.includes(`/account`) &&
                (notificationId == "1" || notificationId == "2") &&
                store.dispatch(GetLastRewardNotifications());

              // end of the logic
              const notification = new Notification(
                payload && payload.notification && payload.notification.title,
                {
                  body:
                    payload &&
                    payload.notification &&
                    payload.notification.body,
                  icon:
                    payload &&
                    payload.notification &&
                    payload.notification.image,
                }
              );
              notification.addEventListener("click", (event) => {
                // handle logic of
                const id = payload && payload.data && payload.data.id;
                if (Cookies.get("token")) {
                  //  to handle read and unreadnotfification mark in logged in case (in notification center when the user clicks on the coming notification from firebase)
                  const request = {
                    id: Number(id),
                  };
                  store.dispatch(ReadNotificationStatus(request));
                } else {
                  localStorage.setItem("ReadNotificationId", id);
                }
                NotificationMapping(
                  history,
                  payload.data ? payload.data : undefined
                );
              });
              // handle message
            },
            (error) => {
              console.log("Error registering message listener:", error);
            }
          );
        } else {
          console.log("Notification permission denied.");
        }
      });
    } catch (err) {
      console.log("FireBase.js Error : ", err);
    }
  }, []);

  return deviceToken;
};

export default useFirebaseMessaging;
